exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2BH1gxTOKlZuQMMMKD7b01{max-height:300px;overflow-x:hidden;overflow-y:scroll}html[dir] ._2BH1gxTOKlZuQMMMKD7b01{padding:3px 0;background:var(--white)}.y733ACJZ2Y68EYRzSJhx8{width:65px}html[dir] ._3fbdrKZ9IwmSRa66c3NI-k{background:var(--neutralLight)}", ""]);
// Exports
exports.locals = {
	"fontPickerContainer": "_2BH1gxTOKlZuQMMMKD7b01",
	"fontSizePicker": "y733ACJZ2Y68EYRzSJhx8",
	"comboBoxOptionHovered": "_3fbdrKZ9IwmSRa66c3NI-k"
};